<script>
	export default {
        extends: app.base.attachmentHelper,
		props: {
		},
		data: function(){
            return {
				apiBase: "OVERLOAD",
                items: {data: []},
                new_message: "",
                preset_message_id: null,
                cache: [],
                savedItems: [],
                have_question_answers: false,
                save_timer: null,
                attached_form: null,
                form_submission_id: null,
            }
		},
        computed: {
            
        },
        watch: {
            attached_images: function() {
                if(this.environment_settings.MIX_CACHE_ATTACHMENTS) {
                    this.saveDraft();
                }
            },
            attached_documents: function() {
                if(this.environment_settings.MIX_CACHE_ATTACHMENTS) {
                    this.saveDraft();
                }
            },
            "new_message": function() {
                if(this.environment_settings.MIX_ENABLE_CACHE) {
                    if (this.save_timer) {
                        clearTimeout(this.save_timer);
                        this.save_timer = null;
                    }
                    this.save_timer = setTimeout(() => {
                        this.saveDraft();
                    }, 1000);
                }
            }
        },
        mounted() {
        },
		methods: {
            saveDraft() {
                if(this.environment_settings.MIX_ENABLE_CACHE) {
                    if((this.environment_settings.MIX_CACHE_ATTACHMENTS && (this.attached_images.length || this.attached_documents.length)) || this.new_message.length) {
                        
                        var data = {
                            new_message: this.new_message
                        };

                        if(this.environment_settings.MIX_CACHE_ATTACHMENTS) {
                            data["attached_images"] = this.attached_images;
                            data["attached_documents"] = this.attached_documents;
                        }

                        if(typeof this.internal_message != "undefined") {
                            data["internal_message"] = this.internal_message;
                        }

                        this.eSetItem('draft_message', data, this.encryptUniqueKey);
                    }
                    else {
                        this.eRemoveItem('draft_message', this.encryptUniqueKey);
                    }
                }
            },
            initEncryptStorageLocal(proxy_id, thread_id) {
                if(!proxy_id) {
                    proxy_id = 0;
                }
                this.encryptUniqueKey = this.$root.user.id + "-" + proxy_id + "-" + thread_id;
            },
            loadDraftFromLocalStorage() {
                if(this.environment_settings.MIX_ENABLE_CACHE) {
                    var draft_message = this.eGetItem('draft_message', this.encryptUniqueKey);

                    if(draft_message) {
                        if(draft_message.attached_images) {          
                            draft_message.attached_images.forEach(image => {
                                this.convertURIToCanvas(image.tn_data_url).then(canvas => {
                                    image.tn_canvas = canvas;
                                });
                                this.convertURIToCanvas(image.data_url).then(canvas => {
                                    image.resize_canvas = canvas;
                                    image.resize_canvas.toBlob((blob) => {
                                        image.blob = blob;
                                    });
                                });
                                this.attached_images.push(image);
                            });
                            //this.cache = in_progress_qa;
                        }

                        if(draft_message.attached_documents) {
                            draft_message.attached_documents.forEach(obj => {
                                this.attached_documents.push(obj);
                            });
                            //this.cache = in_progress_qa;
                        }

                        if(draft_message.new_message) {
                            this.new_message = draft_message.new_message;
                        }

                        if(draft_message.internal_message) {
                            this.internal_message = draft_message.internal_message;
                        }
                    }
                }
            },
            retrieveSavedItem() {
                if(this.savedItems.length) {
                    var previousAnswer = this.savedItems.pop();
                    if(this.questions[this.current_question].id == previousAnswer.question_id) {
                        //alert(previousAnswer.message);
                        this.new_message = previousAnswer.message;
                        this.attached_images = previousAnswer.attached_images;
                        this.attached_documents = previousAnswer.attached_documents;
                    }
                    else {
                        // If our previous answer on the saved stack doesn't match our question, then we clear the stack
                        // as we must have taken a different branch in the QA.
                        this.savedItems = [];
                    }
                }
            },
            checkRouteChange(to, from, next) {
                if(this.cache.length) {
                    var buttons = [
                    {
                        title: this.$t('translations.dont_save_qa'),
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.eRemoveItem('in_progress_qa', this.encryptUniqueKey);
                            next();
                        }
                    },
                    {
                        title: this.$t('translations.continue_qa'),
                        handler: () => {
                            this.$modal.hide('dialog');
                        }
                    }]
                    var text = this.$t('translations.incomplete_qa_text');
                    if(this.$root.encryptStorage) {
                        text = '<span role="alert" tabindex="0" aria-live="polite">' + this.$t('translations.incomplete_qa_text_saved') + '</span>';
                        buttons.unshift({
                            title: this.$t('translations.save_qa'),
                            handler: () => {
                                this.$modal.hide('dialog');
                                next();
                            }});
                    }
                    this.$modal.show('dialog', {
                    title: this.$t('translations.unsaved_changes_title'),
                    text: text,
                    buttons: buttons,
                    });
                }
                else {
                    this.checkUnsaved(this.originalData, {
                        "new_message": {name: "Message", value: this.new_message}
                    }, to, from, next);
                }
            },
            goToPreviousQuestion() {

                this.savedItems.push({message: this.new_message, attached_images: this.attached_images, attached_documents: this.attached_documents, question_id: this.questions[this.current_question].id});

				this.current_question = 'q-' + this.items.data[this.items.data.length - 1].question_id;



                var previousQuestion = this.items.data.pop();

                // If we cached the current question for sending to the server (which we sould have), we need
                // to remove that item too.
                if(this.cache.length) {
                    this.cache.pop();
                }

				console.log(previousQuestion.message);

				this.renderQuestion();
                this.new_message = previousQuestion.message;
                this.attached_images = previousQuestion.attached_images;
                this.attached_documents = previousQuestion.attached_documents;
                this.errors = [];

                // HERE: When we've finished editing, in the sendMessage function we need to
                // check savedItems and call saveMessage instead, and then pop the item off.
				//this.deleteMessage(previousQuestion.id)

                this.focusLegend();
				
			},
            hasNextQuestion() {
				var next_question = null;

				if(this.current_question != null) {

					for(var index in this.questions[this.current_question].branch_rule) {
						//console.log("Testing branch: " + JSON.stringify(this.questions[this.current_question].branch_rule[index], null, 2));
						if(this.questions[this.current_question].branch_rule[index].rule == this.new_message ||
								this.questions[this.current_question].branch_rule[index].rule == null) {
							return true;
						}
					}
				}
				return false;
			},
            validateMessage(data, options) {
                if(!this.thread_id) {
                    data.thread_id = null;
                    var form = this.objectToForm(data);
                    // @todo Should this be using this.apiRoute? is apiBase needed any more?
                    // or is it actually the other way around. Do we need the localised apiRoute?
                    // Confused.
                    return axios.post(this.$root.apiBase + "/messages/validate"
                        , form
						, {headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
                            return Promise.resolve(res);
                        })
                        .catch((error) => {
                            return Promise.reject(error);
                        });
                }
                else {
                    return Promise.resolve();
                }
            },
            baseCopy(element) {
                var copy = {};
                for(var key in element) {
                    if(typeof element[key] === "string" || typeof element[key] === "number") {
                        copy[key] = element[key];
                    }
                }
                return copy;
            },
            postMessage(route, data, options, thread_data) {
                data.id = -(this.cache.length + 1);
                data.user = this.baseCopy(this.$root.user);
                if(data.question_id) {
                    data.question = this.questions["q-" + data.question_id];
                }
                if(!data.message || !data.message.trim()) {
                    return Promise.reject({response: {data: {"message":"The given data was invalid.","errors":{"message":["Please type something in the message box"]}}}}); // // TODO: fix translation
                }

                return this.validateMessage(data, options).then(() => {
                    this.cache.push(data);

                    if(this.thread_id || thread_data) {
                        this.cache.forEach((value, index) => {
                            this.cache[index].thread_id = this.thread_id;
                        });
                        var form = this.objectsToForm(this.cache);
                        
                        // Message for existing thread
                        if(this.thread_id) {
                            form.append("thread_id", this.thread_id);
                        }
                        // Automatically creating a new thread (has to be atomic)
                        else if(thread_data) {
                            Object.keys(thread_data).forEach(key => {
                                if(typeof thread_data[key] === "object") {
                                    form.append(key, JSON.stringify(thread_data[key]));
                                }
                                else {
                                    form.append(key, thread_data[key]);
                                }
                            })
                        }

                        return axios.post(route
                            , form
                            , {headers: {'Content-Type': 'multipart/form-data' }}).then((res) => {
                                this.cache = [];
                                return Promise.resolve(res);
                            })
                            .catch((error) => {
                                if(error.response && error.response.status == "403" && error.response.data.availability) {
                                    //this.addNotification({type: "danger", content: error.response.data.message});
                                    this.$root.provider.calc_service_status = error.response.data.availability;
                                    //this.$root.provider.calc_service_status = 1;
                                }
                                else {
                                    // Get rid of the rejected message from the cache.
                                    this.cache.pop();
                                }
                                return Promise.reject(error);
                            });
                    }
                    else {
                        return Promise.resolve({data: {message: data, thread: {}}});

                        // return Promise.reject(new Error("Cache failure"));

                        // return Promise.reject(new Error("Cache failure"));
                        // return axios.post(route
                        //     , data
                        //     , options);
                    }
                })
                .catch((error) => {
                    if(error.response && error.response.status == "403" && error.response.data.availability) {
                        //this.addNotification({type: "danger", content: error.response.data.message});
                        this.$root.provider.calc_service_status = error.response.data.availability;
                        this.$root.minuteOffset = -this.moment.utc().diff(error.response.data.utc, 'minutes');
                        //this.$root.provider.calc_service_status = 1;
                    }
                    else {
                        // Get rid of the rejected message from the cache.
                        // this.cache.pop();
                    }
                    return Promise.reject(error);
                });
            },
            postMessageOLD(route, data, options) {
                var message = {};
                message.id = -(this.cache.length + 1);
                message.user = this.$root.user;
                var data_object = this.formToObject(data);
                // for(var key in data_object) {
                //     //console.log(key);
                //     if(key == "data") {
                //         var data_embed = JSON.parse(data_object[key]);
                //         for(var key_embed in data_embed) {
                //             message[key_embed] = data_embed[key_embed];

                //         }
                //     }
                //     else {
                //         message[key] = data_object[key];
                //     }
                // }

                data.forEach(function(value, key) {
                    //console.log(key);
                    if(key == "data") {
                        var data_embed = JSON.parse(value);
                        for(var key_embed in data_embed) {
                            message[key_embed] = data_embed[key_embed];
                        }
                    }
                    // Special PHP style array vars
                    else if(key.endsWith("[]")) {
                        key = key.substring(0, key.length - 2);
                        if(!Array.isArray(message[key])) {
                            message[key] = [];
                        }
                        message[key].push(value)
                    }
                    else {
                        message[key] = value;
                    }
                });

                if(this.thread_id) {

                }
                else {


                    if(!message.message || !message.message.trim()) {
                        return Promise.reject({response: {data: {"message":"The given data was invalid.","errors":{"message":["Please type something in the message box"]}}}});
                    }

                    this.cache.push(message);

                    return Promise.resolve({data: {message: message, thread: {}}});

                    // return Promise.reject(new Error("Cache failure"));

                    // return Promise.reject(new Error("Cache failure"));
                    // return axios.post(route
                    //     , data
                    //     , options);
                }
            },
			loadThumbnails() {
				if(this.items && this.items.data && Array.isArray(this.items.data)) {
					this.items.data.forEach((item) => {
						if(Array.isArray(item.message_image)) {
							item.message_image.forEach((image) => {
								if(!this.image_data.find((obj) => {return obj.id == image.image.id})) {
									axios.get(this.$root.apiBase + '/messageimage/thumb/' + image.image.id + (this.thread && this.thread.archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

										let imageR = btoa(
		          							new Uint8Array(res.data)
		            							.reduce((data, byte) => data + String.fromCharCode(byte), '')
		        						);
										this.image_data.push({id: image.image.id, name: image.image.name, tn_width: image.image.tn_width, tn_height: image.image.tn_height, width: image.image.width, height: image.image.height, data: null, tn_data: `data:${res.headers['content-type'].toLowerCase()};base64,${imageR}`});

										// var imageR = new Image();
										// imageR.src = res.data;
										// var canvas = document.createElement("canvas");
										// var ctx = canvas.getContext("2d");
										// ctx.drawImage(imageR, 0, 0, imageR.width, imageR.height);
										// this.image_data.push({id: image.image.id, tn_data: canvas.toDataURL()});
									}).catch((error) => {
										console.log(error);
					                });
								}
							});
						}
                        if(Array.isArray(item.form_submission) && item.form_submission.length && Array.isArray(item.form_submission[0].form_submission_image)) {
							item.form_submission[0].form_submission_image.forEach((image) => {
								if(!this.image_data.find((obj) => {return obj.id == image.image.id})) {
									axios.get(this.$root.apiBase + '/formsubmissionimage/thumb/' + image.image.id + (this.thread && this.thread.archived ? "/1" : ""), { responseType: 'arraybuffer' }).then((res) => {

										let imageR = btoa(
		          							new Uint8Array(res.data)
		            							.reduce((data, byte) => data + String.fromCharCode(byte), '')
		        						);
										this.image_data.push({id: image.image.id, name: image.image.name, tn_width: image.image.tn_width, tn_height: image.image.tn_height, width: image.image.width, height: image.image.height, data: null, tn_data: `data:${res.headers['content-type'].toLowerCase()};base64,${imageR}`});

										// var imageR = new Image();
										// imageR.src = res.data;
										// var canvas = document.createElement("canvas");
										// var ctx = canvas.getContext("2d");
										// ctx.drawImage(imageR, 0, 0, imageR.width, imageR.height);
										// this.image_data.push({id: image.image.id, tn_data: canvas.toDataURL()});
									}).catch((error) => {
										console.log(error);
					                });
								}
							});
						}
					});
				}
			},
            // @SYNC Message.php
            formatMessageContent(message) {
                var output = "";
                if(this.isMultiProviderThread(this.thread, this.items.data) && message.automated == 1) {
                    output = message.provider.name + ": ";
                }
                /**
                 * THIS WAS JUST AN IDEA OF HOW TO REFORMAT OLD MESSAGE CONTENT FROM
                 * BEFORE WE USED THE AUTOMATED FLAG TO INDICATE THE AUTOMATION TYPE
                 * We need a temporary solution here, so that we can reformat/translate these automated messages
                 * on the fly, rather than using the static text in the message. Use the "automated" field, but
                 * also need to do the string comparisons, until we have time/confidence to update the messages
                 * table.
                 */
                // if (message.assigned_group_id || message.assigned_user_id) {
                //     return this.formatContent(message.provider.name + ": " + message.message, !message.automated);
                // }
                // if(message.message.endsWith("completed this request.")) {
                //     return this.formatContent(message.provider.name + ": " + message.message, !message.automated);
                // }
                
                // SECURITY WARNING: Never JSON parse non-automated messages, otherwise users could inject JSON in to 
                // their messages.
                switch(message.automated) {
                    //case 1: return this.formatContent($output, !message.automated);
                    case 2:
                        try {
                            var parameters = JSON.parse(message.message);
                            
                            // This is a bit muddy now, but all these ways are old, but may still be in the data,
                            // so we need to just make sure that they don't interfere with the new way of doing things.
                            if(!parameters.name) {
                                // Old static way of storing the secondary user details
                                if(parameters.user && !parameters.user.type) {
                                    parameters.name = this.formatNameWithProvider(parameters.user, message.provider, this.thread, this.items.data);
                                }
                                // New dynamic way of storing the secondary user details
                                else if(message.assigned_user && !message.assigned_user.type) {
                                    parameters.name = this.formatNameWithProvider(message.assigned_user, message.provider, this.thread, this.items.data);
                                }
                            }

                            // New way of handling dynamic messages
                            Object.keys(parameters).forEach((index) => {
                                // console.info(parameters[index]);
                                // console.info(typeof parameters[index]);
                                if(typeof parameters[index] === "object") {
                                    switch(parameters[index].type) {
                                        // These should now all arrive as "user" and then be looked up by ID (so it's safe) in all our user storage ($root.lookup.staff and $root.user)
                                        // However they all need to still be here as they exist in the database in old messages.
                                        case "staff": // DEPRECATED 
                                        // WARNING: Some old data in the database includes the robot user as "staff", 
                                        // which is fine because it defaults to static, but be aware.
                                        case "robot": // DEPRECATED - We never actually load the robot, so if this one comes through, we use the static version
                                        case "network_admin": // DEPRECATED - If it ever happens (not supported currently) then it will be looked up in the staff and user list.
                                        case "patient": // DEPRECATED
                                        case "user": 
                                            // Is the user in our staff user list?
                                            var staff = this.$root.lookup.staff.find(staff => {return staff.id == parameters[index].id});
                                            if(staff) {
                                                parameters[index] = this.formatNameWithProvider(staff, message.provider, this.thread, this.items.data);
                                            }
                                            // Is it the patient?
                                            else if(this.$root.user.id == parameters[index].id) {
                                                parameters[index] = this.formatNameWithProvider(this.$root.user, message.provider, this.thread, this.items.data);
                                            }
                                            // Can't find it, use the static version
                                            else if(parameters[index].static) {
                                                parameters[index] = parameters[index].static;
                                            }
                                            // No static version available - worst case fallback
                                            else {
                                                parameters[index] = "[UNKNOWN]";
                                            }
                                        break;
                                        case "group":
                                            var group = this.$root.lookup.user_groups.find(group => {return group.id == parameters[index].id});
                                            if(group) {
                                                parameters[index] = group.name;
                                            }
                                            else if(parameters[index].static) {
                                                parameters[index] = parameters[index].static;
                                            }
                                            else {
                                                parameters[index] = "[UNKNOWN]";
                                            }
                                        break;
                                        case "provider":
                                            var provider = this.$root.provider.provider_provider_xref.find(provider_provider_xref => {return provider_provider_xref.relation.id == parameters[index].id});
                                            if(provider) {
                                                parameters[index] = provider.relation.name;
                                            }
                                            else if(parameters[index].static) {
                                                parameters[index] = parameters[index].static;
                                            }
                                            else {
                                                parameters[index] = "[UNKNOWN]";
                                            }
                                        break;
                                        case "datetime":
                                            parameters[index] = this.moment(parameters[index].value).format('DD/MM/YYYY HH:mm');
                                        break;
                                        case "priority":
                                            parameters[index] = this.$t(`translations.priority_${parameters[index].id}`);
                                        break;
                                        case "form":
                                            // Don't bother updating the form names dynamically. Too much overhead.
                                            parameters[index] = parameters[index].static;
                                        break;
                                        case "blood_pressure_range":
                                            // Don't bother looking up blood pressure ranges dynamically. Too much overhead.
                                            parameters[index] = parameters[index].static;
                                        break;
                                        case "custom_action":
                                            var custom_action = this.$root.provider.custom_action.find(custom_action => {return custom_action.id == parameters[index].id});
                                            if(custom_action) {
                                                parameters[index] = custom_action.title;
                                            }
                                            else if(parameters[index].static) {
                                                parameters[index] = parameters[index].static;
                                            }
                                            else {
                                                parameters[index] = "[UNKNOWN]";
                                            }
                                        break;
                                    }
                                }
                            })

                            output += this.autobrand(parameters.translation, parameters);
                        }
                        catch(e) {
                            console.warn("!!!!", e.message);
                            output += "MALFORMED AUTOMATED MESSAGE. PLEASE REPORT THIS TO THE ASKMYGP TECHNICAL TEAM.";
                            output += message.message;
                        }
                        break;
                    default: 
                        if(message.question_id) {
                            output += this.autobrand(message.message);
                        }
                        else {
                            output += message.message;
                        }
                }
                return this.formatContent(output, !message.automated);
            },
            formatNameForItem(item, compact = false) {
                var name = this.formatNameWithProvider(item.user, item.provider, this.thread, this.items.data);

                if(!compact) {
                    name += " " + this.$t('translations.wrote');
                }
                
                return name;
            },
            getLatestMessageTime() {
                // DO NOT USE CURRENTLY!
                // This is for when/if we switch to using the updated_at field to setRead
                // and to show notifications. See AV3-1273 for discussion.
                if(this.items && this.items.data && Array.isArray(this.items.data)) {
                    var latest_item = this.items.data.sort((firstEl, secondEl) => {if(firstEl.updated_at > secondEl.updated_at) return 1; else if(firstEl.updated_at < secondEl.updated_at) return -1; return 0;}).pop();
                    if(latest_item) {
                        return latest_item.updated_at;
                    }
                }
                return null;
            },
            focusLegend() {
                setTimeout(() => {
					this.$nextTick(() => {
                        if(this.$refs.qa_legend && this.$refs.qa_legend.focus) {
						    this.$refs.qa_legend.focus();
                        }
					});
				}, 500);	
                
                // if(this.$refs.qa_legend && this.$refs.qa_legend.focus) {
                //     this.$nextTick(() => {
                //         this.$refs.qa_legend.focus();
                //     });
                // }
            },
            getFormTitle(form_submission) {
                if(form_submission.form_version) {
                    return form_submission.form_version.title;
                }
                else if(form_submission.form_submission_form) {
                    return form_submission.form_submission_form.title;
                }
                
            }
        }
    }
</script>
